import { useMemo } from 'react';

import { CertificateType } from '../../../utils/interfaces/DbInterfaces';
import { ICompDefault } from '../../../utils/interfaces/TypesInterfaces';

import styles from './Certificate.module.scss';

interface ICertificateComp extends ICompDefault {
  data: CertificateType;
}

const Certificate = ({ data, className }: ICertificateComp) => {
  const dateCompleted = useMemo(() => {
    if (data.dateCompleted) {
      const myDate = new Date(data.dateCompleted); // dateCompleted is already in milliseconds
      const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      return `Earned ${monthNames[myDate.getMonth()]} ${myDate.getFullYear()}`;
    }

    return '';
  }, [data.dateCompleted]);

  return (
    <div className={`${styles.certificateCard}${className ? ` ${className}` : ''}`}>
      <div className={styles.certificateImage}>
        <img src="/images/certificate-template.svg" alt={`${data.title} Certificate`} className={styles.certificateImg} />
      </div>

      <div className={styles.certificateInfo}>
        <h3 className={styles.certificateTitle}>{data.title}</h3>
        <p className={styles.certificateDate}>{dateCompleted}</p>
        <a href={data.verifyUrl} target="_blank" rel="noreferrer" className={styles.verifiedButton}>
          Verified
        </a>
      </div>
    </div>
  );
};

export default Certificate;
